import { ShopApiError } from "./shopAdminApi";

// A rejection of a retry says nothing about a previous request whose response
// was lost. Keep its immutable intent until the original receipt is recovered.
export function isDefiniteShopRejection(error: unknown, previouslyUncertain = false): boolean {
  return !previouslyUncertain && error instanceof ShopApiError &&
    [400, 401, 403, 404, 405, 409, 422].includes(error.status);
}
